import { Button, Tooltip } from 'antd';
import { doc } from 'firebase/firestore';
import React, { useContext, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useDocumentData } from 'react-firebase-hooks/firestore';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';

import ProfileIcon from '../../components/UI/Icon-SVG/ProfileIcon';
import { Context } from '../../index';
import useCreatePrivateChat from '../Chat/hooks/useCreatePrivateChat';

const Container = styled.div`
  width: 100%;
  background: #fff;
  display: flex;
  flex-direction: row;
  flex: 1;
  overflow: auto;
  padding-bottom: 24px;

  .article {
    font-family: Open Sans, sans-serif;
    font-size: 18px;
    font-weight: bold;
    line-height: 27px;
    margin: 0;
  }

  .article-shadow {
    font-family: Open Sans, sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #a6b0cf;
    margin-top: 6px;
  }
`;

const View = styled.div`
  width: 40%;
  display: flex;
  flex-direction: column;
  padding: 24px;
  max-width: 520px;
`;

const AvatarBlock = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #c6dbff;
  position: relative;
  margin-top: 10px;

  .avatar__none {
    position: absolute;
    top: 26%;
    left: 25%;
  }

  img {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background-size: cover;
  }
`;

const NameWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin-top: 15px;

  svg path {
    fill: #397ef3;
  }
`;

const Text = styled.p`
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  margin: 0;
`;

const ProfileItem = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.p`
  font-family: 'Open Sans', sans-serif;
  font-size: 12px;
  margin: 0;
  color: #a6b0cf;
  margin-bottom: 6px;
`;

const EmailWrapper = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: row;
`;

const DirectMessage = styled(Button)`
  max-width: 200px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const Share = styled(Button)`
  max-width: 200px;
  margin-top: 20px;
`;

const EditProfileBtn = styled(Button)`
  max-width: 200px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const ProfileClient = ({ isMyProfile = true }) => {
  const { auth, firestore } = useContext(Context);
  const [shareTooltipIsVisible, setShareTooltipIsVisible] = useState(false);
  const [user] = useAuthState(auth);
  const { id } = useParams();
  const userId = isMyProfile ? user.uid : id;
  const history = useHistory();

  const [userData] = useDocumentData(doc(firestore, 'users', userId));
  const [userFullProfileData] = useDocumentData(doc(firestore, 'user_full_profile', userId));
  const { creatPrivateChat } = useCreatePrivateChat();

  const goToEditProfile = () => {
    history.push('/edit-profile');
  };

  const share = () => {
    setShareTooltipIsVisible(true);
    setTimeout(() => setShareTooltipIsVisible(false), 5000);
    const el = document.createElement('textarea');
    el.value = `https://skylex.page.link/${userId}`;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  };

  const avatarUrl = userFullProfileData?.avatar?.avatar_path;
  const name =
    userData?.first_name && userData?.last_name
      ? `${userData?.first_name} ${userData?.last_name}`
      : '-';
  const { position, address, email, additional_phone, location, about } = userFullProfileData ?? {};

  return (
    <Container>
      <View>
        <p className="article">General information</p>
        <AvatarBlock>
          {!avatarUrl ? (
            <div className="avatar__none">
              <ProfileIcon color="#397EF3" />
            </div>
          ) : (
            <img src={avatarUrl} alt="Avatar" />
          )}
        </AvatarBlock>
        <NameWrapper>
          <Text>{name}</Text>
        </NameWrapper>
        {!isMyProfile && (
          <Tooltip title="User link saved to clipboard" visible={shareTooltipIsVisible}>
            <Share onClick={share}>Share</Share>
          </Tooltip>
        )}
        {!isMyProfile && (
          <DirectMessage onClick={() => creatPrivateChat(user.uid, id)}>
            Direct Messages
          </DirectMessage>
        )}
        {isMyProfile && <EditProfileBtn onClick={goToEditProfile}>Edit Profile</EditProfileBtn>}
        <ProfileItem style={{ marginTop: 16 }}>
          <Label>About</Label>
          <Text>{about || '-'}</Text>
        </ProfileItem>
        <ProfileItem style={{ marginTop: 16 }}>
          <Label>Position</Label>
          <Text>{position || '-'}</Text>
        </ProfileItem>
        <ProfileItem style={{ marginTop: 16 }}>
          <Label>Address</Label>
          <Text>{address || '-'}</Text>
        </ProfileItem>
        <ProfileItem style={{ marginTop: 16 }}>
          <Label>Additional phone number</Label>
          <Text>{additional_phone || '-'}</Text>
        </ProfileItem>
        <EmailWrapper>
          <ProfileItem style={{ marginRight: 100 }}>
            <Label>Email</Label>
            <Text>{email || '-'}</Text>
          </ProfileItem>
        </EmailWrapper>
      </View>
    </Container>
  );
};

export default ProfileClient;
